import { action } from 'easy-peasy';
import { IActionUpdateMedication } from '../types';

const updateMedication: IActionUpdateMedication = action((state, payload) => {
  state.items = state.items
    .map(item => {
      if (item.id !== payload.id) return item;
      return {
        ...item,
        ...payload,
      };
    })
    .sort((a, b) => a.content.localeCompare(b.content));
});

export default updateMedication;
